import { FC } from 'react';

export const PurchaseFormCard: FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <section className="relative flex flex-col items-center rounded-sm border border-divider/20 bg-white p-6">
    {children}
  </section>
);
